type Listener = (data: any) => void;

const listeners = new Map<string, Set<Listener>>();

export function onSSEEvent(type: string, fn: Listener): () => void {
  if (!listeners.has(type)) listeners.set(type, new Set());
  listeners.get(type)!.add(fn);
  return () => { listeners.get(type)?.delete(fn); };
}

export function emitSSEEvent(type: string, data: any) {
  const fns = listeners.get(type);
  if (!fns) return;
  for (const fn of fns) {
    try { fn(data); } catch {}
  }
}
